exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".payment-card{padding:5px;margin-bottom:16px;background-image:url(" + require("../../assets/img/place_holder1.svg") + ");background-repeat:no-repeat;background-size:100%}.payment-card input{font-size:20px;font-family:\"Open Sans\"}.expiry{font-family:\"Open Sans\";padding:5px;width:200px}.cvc{font-family:\"Open Sans\";width:50px;float:right;margin-top:-27px;padding:5px;padding-left:10px;background-image:url(" + require("../../assets/img/place_holder.svg") + ")}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss"}!./src/components/PaymentComponent/style.scss
// module id = 1773
// module chunks = 0